/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SmartInstallmentPlanDto
 */
export interface SmartInstallmentPlanDto {
    /**
     * 
     * @type {string}
     * @memberof SmartInstallmentPlanDto
     */
    'interval': SmartInstallmentPlanDtoIntervalEnum;
    /**
     * 
     * @type {number}
     * @memberof SmartInstallmentPlanDto
     */
    'installments': number;
}

/**
    * @export
    * @enum {string}
    */
export enum SmartInstallmentPlanDtoIntervalEnum {
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    SEMIANNUALLY = 'semiannually',
    ANNUALLY = 'annually'
}


